import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs: {
  q: string;
  a: string;
}[] = [{
  q: 'Can’t I just find all this free on YouTube and Pinterest?',
  a: 'You can find pieces — scattered across 500 videos, blog posts and boards, with no order and no system. This is everything, sequenced and ready to execute. You’re not paying for information; you’re paying for the operating system.'
}, {
  q: '300 pages sounds overwhelming. Will I actually use it?',
  a: 'It’s split into 6 operational volumes — you open the one today’s problem requires. Plus, Bonus 2 (the Quick-Start Checklist) tells you exactly what to do in your first 48 hours.'
}, {
  q: 'Is this for beginners or experienced planners?',
  a: 'Both. If you’re starting, it’s the infrastructure nobody teaches you. If you’re already planning weddings, it’s how you professionalize, systemize and finally raise your prices.'
}, {
  q: 'Does this work in my country?',
  a: 'Yes. Currencies and vendors change — the systems don’t. Onboarding, budgeting, timelines and vendor management are universal.'
}, {
  q: 'How do I receive it?',
  a: 'Instant PDF download after checkout. Read it on any device, print whatever you need.'
}, {
  q: 'Can I use the templates with my own branding?',
  a: 'Yes. The client-facing materials are designed for you to add your logo and use directly with your couples.'
}, {
  q: 'I’ve bought templates before and never opened them.',
  a: 'This isn’t a loose template. It’s a sequenced operating system with a 48-hour quick-start path — built to be used, not stored.'
}, {
  q: 'What if it’s not for me?',
  a: '7-day guarantee. Full refund, no questions asked.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-97" data-mp="3nyig2jtwcue1">
      <div className="mx-auto max-w-3xl px-5" data-id="element-98" data-mp="3o1ehwj8v837r">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-99" data-mp="1uhw7gsj9uclh">
          Questions, answered
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-100" data-mp="1potealiep55t" />

        <ul className="mt-12 divide-y divide-gold-soft/70 border-y border-gold-soft/70" data-id="element-101" data-mp="1ks2ylzaikbkx">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} data-id="element-102" data-mp="2denqd0uwipp0" data-mpi={index}>
                <h3 data-id="element-103" data-mp="2ddme4t25fx5p">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-104" data-mp="28gm7afxh6qdj">
                    <span className="font-serif text-lg sm:text-xl text-ink" data-id="element-105" data-mp="s3xdhbfjskkk">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-106" data-mp="o352odr127m6" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-107" data-mp="3dg2cieigvyqv">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.4, 0, 0.2, 1]
              }} className="overflow-hidden" data-id="element-108" data-mp="3ielvq75oewfj">
                      <p className="pb-7 pr-10 text-[15px] leading-relaxed text-ink-soft" data-id="element-109" data-mp="8h3vkpc09hk">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}